import { type User } from '@halo/chat-sdk-react';
import { useEffect, useState } from 'react';
import { useStaticAppStore } from './useStaticAppStore';

export function useUserInfo(user_id: string | undefined) {
  const { client } = useStaticAppStore();
  const [user, setUser] = useState<User | undefined>(undefined);

  useEffect(() => {
    if (user_id && client) {
      const result = client.Api.user.resolveUsersInfo(user_id, (res) => {
        setUser(res);
      });
      return result.removeListener;
    } else {
      setUser(undefined);
    }
  }, [client, user_id]);

  return {
    user,
  };
}
